import { useMemo } from "react";

import ModalSkeleton from "../../../Components/Skeleton/modal-skeleton";

import { useCreditReportDetails } from "../../../CustomHooks/Queries";

import { modalVariants, monthNames } from "../../../Utils/constants";

export default function renderCreditBuilderTracker(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle } = modalContext;

  updateModalComponent(CreditBuilderTracker);
  setModalVariant(modalVariants.flexDialog);
  setModalTitle("Credit Builder Tracker");
}

const CreditBuilderTracker = () => {
  const { isLoading: isLoadingCreditReporting, data: creditReporting } = useCreditReportDetails();

  const creditBuilderTrackerList = useMemo(() => {
    return creditReporting?.data?.data.credit_builder_tracker ?? [];
  }, [creditReporting?.data?.data.credit_builder_tracker]);

  return isLoadingCreditReporting ? (
    <ModalSkeleton />
  ) : (
    <div className="modal-dialog-content credit-builder-tracker mb-6">
      {creditBuilderTrackerList.map((payment, idx) => {
        const isReported = payment?.is_reported;
        return (
          <div key={idx} className="credit-builder-item">
            <h5 className="text-lg-medium color--mist mb-3">
              {`${monthNames[parseInt(payment.month) - 1] || ""} ${payment.year}`}
            </h5>
            <p className="text-base-regular color--mist mb-0">
              {isReported ?? false ? "✅" : "⏸️"} {payment?.description}
            </p>
          </div>
        );
      })}
    </div>
  );
};
